import axios from 'axios';

const state = {
    
};

const getters = {
    
};

const actions = {
    async getSiteParameter(state, data) {// update user additional records
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getSiteParameterUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`}; 
        let response = await axios.post(url, {data}, { headers: header});// make api call
        return response.data;        
    },
};

const mutations = {
    
};

export default {
    state,
    getters,
    actions,
    mutations
}